import { render, staticRenderFns } from "./InfoSubTitle.vue?vue&type=template&id=40c71d5e&scoped=true&"
import script from "./InfoSubTitle.vue?vue&type=script&lang=js&"
export * from "./InfoSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./InfoSubTitle.vue?vue&type=style&index=0&id=40c71d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c71d5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c71d5e')) {
      api.createRecord('40c71d5e', component.options)
    } else {
      api.reload('40c71d5e', component.options)
    }
    module.hot.accept("./InfoSubTitle.vue?vue&type=template&id=40c71d5e&scoped=true&", function () {
      api.rerender('40c71d5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Statistics/TouchpointInfo/InfoSubTitle.vue"
export default component.exports